
$(document).ready(function(){
	

	
	
	 /* initialize the scrollTop Nav 
     -----------------------------------------------------------------*/
	
    $(".nav .nav-item").click(function(){
		 $(".content-wrapper").scrollTop();
    });
	
	

   /* initialize the toggle multiple select box  
     -----------------------------------------------------------------*/
  
  
  $('.toggleBtn').click( function(e) {
        
        e.preventDefault(); // stops link from making page jump to the top
        e.stopPropagation(); // when you click the button, it stops the page from seeing it as clicking the body too
        $('.toggleContentBox').toggle();
        
    });
    
    $('.toggleContentBox').click( function(e) {
        
        e.stopPropagation(); // when you click within the content area, it stops the page from seeing it as clicking the body too
        
    });
    
    $('body').click( function() {
       
        $('.toggleContentBox').hide();
        
    });

	
	
	 /* initialize the calendar
     -----------------------------------------------------------------*/
    //Date for the calendar events (dummy data)
    var date = new Date()
    var d    = date.getDate(),
        m    = date.getMonth(),
        y    = date.getFullYear()
   /*  $('#calendar').fullCalendar({
      header    : {
        left  : 'prev,next today',
        center: 'title',
        right : 'month,agendaWeek,agendaDay'
      },
      buttonText: {
        today: 'today',
        month: 'month',
        week : 'week',
        day  : 'day'
      },
      //Random default events
      events    : [
        {
          title          : 'Grace Bay Beach, Turks and Caicos - Dan Reardon',
          start          : new Date(y, m, d - 8),
          end            : new Date(y, m, d - 2),
          backgroundColor: '#8DB9CA', //bluedark
          borderColor    : '#8DB9CA' //bluedark
		  
        },
        {
          title          : 'Los Cabos, Mexico - Judy Capes',
          start          : new Date(y, m, d - 5),
          end            : new Date(y, m, d - 2),
          backgroundColor: '#DCE9EE', //blueLight
          borderColor    : '#DCE9EE' //blueLight
        },
        {
          title          : 'Deer Valley, Utah - Michele Cone',
          start          : new Date(y, m, d - 9),
          end            : new Date(y, m, d - 7),
          backgroundColor: '#8DB9CA', //bluedark
          borderColor    : '#8DB9CA' //bluedark
        },
        {
          title          : 'Chamonix, France - Loren Cook',
          start          : new Date(y, m, d - 12),
          end            : new Date(y, m, d - 3),
          backgroundColor: '#DCE9EE', //blueLight
          borderColor    : '#DCE9EE' //blueLight
        },
        {
          title          : 'Hilton Head Island, South Carolina - William Ellis',
          start          : new Date(y, m, d + 1, 19, 0),
          end            : new Date(y, m, d + 1, 22, 30),
          allDay         : false,
          backgroundColor: '#8DB9CA', //bluedark
          borderColor    : '#8DB9CA' //bluedark
        },
		{
          title          : 'Los Cabos, Mexico - Judy Capes',
          start          : new Date(y, m, d - 28),
          end            : new Date(y, m, d - 16),
          allDay         : false,
          backgroundColor: '#DCE9EE', //blueLight
          borderColor    : '#DCE9EE' //blueLight
        },
		{
          title          : 'Deer Valley, Utah - Michele Cone',
          start          : new Date(y, m, d - 28),
          end            : new Date(y, m, d - 18),
          allDay         : false,
          backgroundColor: '#8DB9CA', //bluedark
          borderColor    : '#8DB9CA' //bluedark
        },
        {
          title          : 'Telluride, Colorado - Jeff Diaz',
          start          : new Date(y, m, d - 15),
          end            : new Date(y, m, d - 10),
          backgroundColor: '#8DB9CA', //bluedark
          borderColor    : '#8DB9CA' //bluedark
        }
      ],
      editable  : true,
      droppable : true, // this allows things to be dropped onto the calendar !!!
      drop      : function (date, allDay) { // this function is called when something is dropped

        // retrieve the dropped element's stored Event Object
        var originalEventObject = $(this).data('eventObject')

        // we need to copy it, so that multiple events don't have a reference to the same object
        var copiedEventObject = $.extend({}, originalEventObject)

        // assign it the date that was reported
        copiedEventObject.start           = date
        copiedEventObject.allDay          = allDay
        copiedEventObject.backgroundColor = $(this).css('background-color')
        copiedEventObject.borderColor     = $(this).css('border-color')

        // render the event on the calendar
        // the last `true` argument determines if the event "sticks" (http://arshaw.com/fullcalendar/docs/event_rendering/renderEvent/)
        $('#calendar').fullCalendar('renderEvent', copiedEventObject, true)

        // is the "remove after drop" checkbox checked?
        if ($('#drop-remove').is(':checked')) {
          // if so, remove the element from the "Draggable Events" list
          $(this).remove()
        }

      }
    }) */

    /* ADDING EVENTS */
    /* var currColor = '#3c8dbc' //Red by default
    //Color chooser button
    var colorChooser = $('#color-chooser-btn')
    $('#color-chooser > li > a').click(function (e) {
      e.preventDefault()
      //Save color
      currColor = $(this).css('color')
      //Add color effect to button
      $('#add-new-event').css({
        'background-color': currColor,
        'border-color'    : currColor
      })
    })
    $('#add-new-event').click(function (e) {
      e.preventDefault()
      //Get value and make sure it is not null
      var val = $('#new-event').val()
      if (val.length == 0) {
        return
      }

      //Create events
      var event = $('<div />')
      event.css({
        'background-color': currColor,
        'border-color'    : currColor,
        'color'           : '#fff'
      }).addClass('external-event')
      event.html(val)
      $('#external-events').prepend(event)

      //Add draggable funtionality
      ini_events(event)

      //Remove event from text input
      $('#new-event').val('');
    }) */
  
});



// WEBPACK FOOTER //
// src/assets/js/mainCustom.js